import { Chart } from 'chart.js';

export const htmlLegendPlugin = {
  id: 'htmlLegend',
  afterUpdate(chart: Chart<'line'>) {
    const items = chart.options?.plugins?.legend?.labels?.generateLabels?.(chart);
    const ul = document.createElement('ul');
    items?.forEach((item) => {
      const li = document.createElement('li');
      const boxSpan = document.createElement('span');
      boxSpan.style.background = item.fillStyle?.toString() || '';
      li.appendChild(boxSpan);
      li.appendChild(document.createTextNode(item.text));
      ul.appendChild(li);
    });
    const jsLegend = document.getElementById('js-legend');
    jsLegend?.appendChild(ul);
  },
};
